module.exports = __webpack_public_path__ + "img/900347211.398f96c0.png";